import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rol-permissions',
  templateUrl: './rol-permissions.component.html',
  styleUrls: ['./rol-permissions.component.scss']
})
export class RolPermissionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    
  }

}
